<template>
  <block-title
    class="tableItem overview"
    :show-line="false"
    :title="title"
  >
    <div slot="icon-right" class="block-icon-right" >
      <a-radio-group
        v-model="selectTime"
        button-style="solid"
        class="order-time"
        size="small"
      >
        <a-radio-button
          v-for="item in timeList"
          :key="item.value"
          :value="item.value"
          @click="getOverview(item.value)"
        >
          {{item.label}}
        </a-radio-button>
      </a-radio-group>
      <a-range-picker v-model="dateTime" @change="changePicker">
        <template #suffixIcon>
          <a-icon type="calendar" />
        </template>
      </a-range-picker>
    </div>
    <div class="goodsBox">
      <div class="tableBox">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :pagination="false"
          size="middle"
          :locale="{emptyText: emptyImage}"
        >
          <div slot="ranking" slot-scope="text">
            <span>{{text}}</span>
          </div>
          <div slot="ratio" slot-scope="text">
            <span>{{ filterRatio(text) }} </span>
          </div>
        </a-table>
      </div>
    </div>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import base from '@/api/base'
import moment from 'moment'
import { lineOrder, goodsStation, transportSku } from '../api'
import Empty from './Empty.vue'
import { topData } from '../constant';

const funcType = {
  line: lineOrder,
  goods: goodsStation,
  detailed: transportSku,
  category: transportSku,
}

export default {
  name: 'TableItem',
  components: {
    BlockTitle,
    // Empty,
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'line'
    },
    isDemo: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectTime: '0',
      dateTime: [moment().startOf('day'), moment().endOf('day')],
      timeList: [
        {
          label: '今天',
          value: '0'
        },
        {
          label: '近7天',
          value: '7'
        },
        {
          label: '近30天',
          value: '30'
        }
      ],
      tableData: []
    }
  },
  computed:{
    getfunction(){
      return funcType[this.type]
    },
    emptyImage() {
      return <Empty />
    }
  },
  created(){
    this.getData()
  },
  methods: {
    changePicker(val) {
      this.selectTime = val?.length ? '' : '0'
      this.getData()
    },
    filterRatio(ratio){
      return `${(ratio * 100).toFixed(2)}%`
    },
    async getData(){
      if (this.isDemo) {
        // this.tableData = topData[this.type]
        const current = topData[this.type]
        const res = await base.getDictionary({
          status: 1,
          type: current.type
        })
        const tableData = [];
        let total = 0
        res.forEach(i => {
          total += Number(i.dictionaryCode || 0)
        })
        res.forEach((item, index) => {
          tableData.push({
            [current.name]: item.dictionaryName,
            [current.val]: Number(item.dictionaryCode || 0),
            ranking: index+1,
            ratio: Number(item.dictionaryCode || 0)/total
          })
        });
        this.tableData = tableData
        return
      }
       const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
       const data={
         startTime: moment(this.dateTime[0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(this.dateTime[1]).format('YYYY-MM-DD HH:mm:ss'),
       }
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
          data.projectIds=projectIds
       }
      if(this.type === 'detailed'){
        data.orderGoodsType = 0
      }
      if(this.type === 'category'){
        data.orderGoodsType = 1
      }
      this.getfunction(data).then((res) => {
        this.tableData = res.map((e, i) => {
          return {
            ...e,
            ranking: i + 1
          }
        })
      })
    },
    getOverview(value) {
      const endTime = moment().endOf('day')
      let startTime = ''
      switch(value) {
        case '7':
          startTime = moment().subtract(6, "days").startOf('day')
          break
        case '30':
          startTime = moment().subtract(29, "days").startOf('day')
          break
        default:
          startTime = moment().startOf('day')
          break
      }
      this.$set(this,'dateTime',[startTime, endTime])
      this.getData()
    },
    filterRank(rank){
      if(rank * 1 === 1){
        return "one all"
      }
      if(rank * 1 === 2){
        return "two all"
      }
      if(rank * 1 === 3){
        return "three all"
      }
      return "all"
    }
  }
}
</script>

<style lang="less" scoped>
.tableItem{
  height: calc(100% - 16px);
  .goodsBox{
    padding: 8px 32px 12px 32px;
  }
  .tableBox{
    margin-top: 10px;
  }
  .order-time{
    margin-right: 12px;
  }
  /deep/ .ant-calendar-picker-input{
    width: 220px !important;
    margin-top: 9px;
    padding-left: 0;
  }
  /deep/ .block-icon-right{
    position: absolute;
    width: 55%;
    top: 10px;
    right: 0;
  }
}
</style>